import { render, staticRenderFns } from "./ColouredValue.vue?vue&type=template&id=05911aaa&scoped=true&"
import script from "./ColouredValue.vue?vue&type=script&lang=js&"
export * from "./ColouredValue.vue?vue&type=script&lang=js&"
import style0 from "./ColouredValue.vue?vue&type=style&index=0&id=05911aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05911aaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
